import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export interface BreadcrumbItem {
  label: string;
  url?: string;
  queryParams?: any;
  isActive?: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class BreadcrumbService {
  private breadcrumbsSubject = new BehaviorSubject<BreadcrumbItem[]>([]);
  public breadcrumbs$ = this.breadcrumbsSubject.asObservable();

  setBreadcrumbs(breadcrumbs: BreadcrumbItem[]) {
    this.breadcrumbsSubject.next(breadcrumbs);
  }

  // Para o componente DetalheMinicipio - apenas 2 níveis
  setDetalheMunicipioBreadcrumbs() {
    const breadcrumbs: BreadcrumbItem[] = [
      { label: 'Clientes e Municípios', url: '/page/admin-dashboard' },
      { label: 'Município', isActive: true }
    ];
    this.setBreadcrumbs(breadcrumbs);
  }

  // Para componentes filhos do município - SEMPRE 3 níveis completos
  setMunicipioBreadcrumbs(componentName: string, cidadeId?: number) {
    const breadcrumbs: BreadcrumbItem[] = [
      { label: 'Clientes e Municípios', url: '/page/admin-dashboard' },
      { 
        label: 'Municípios', 
        url: cidadeId ? '/page/municipio/detalhe' : '/page/admin-dashboard',
        queryParams: cidadeId ? { idCidade: cidadeId } : undefined
      },
      { label: componentName, isActive: true }
    ];
    this.setBreadcrumbs(breadcrumbs);
  }

  // Para componentes normais - apenas 2 níveis
  setNormalBreadcrumbs(componentName: string) {
    const breadcrumbs: BreadcrumbItem[] = [
      { label: 'Clientes e Municípios', url: '/page/admin-dashboard' },
      { label: componentName, isActive: true }
    ];
    this.setBreadcrumbs(breadcrumbs);
  }

  clear() {
    this.breadcrumbsSubject.next([]);
  }
} 